import { gql } from "@apollo/client";

// For some reason compiler is throwing an initialization error for the Alternates.query.js file if this is not at the top level of the folder
export const TRANSIT_ACCOUNT_FIELDS = gql`
	fragment TransitAccountFields on TransitAccount {
		id
		nodeTime
		subsystemAccountReference
		accountStatus
		accountStatusDescription
		accountStatusChangeDateTime
		riderClass
		riderClassDescription
		debtCollectionInfo {
			action
			amountDue
			#Per api doc: We get bankcardCharged only when "action" is "AvailableWait"
			bankcardCharged {
				maskedPan
				expirationMonth
				expirationYear
				creditCardType
			}
			attemptInSeconds
			remainingAttemptsForDay
		}
		tapVoidInfo {
			totalVoidCount
			provisionalVoidCount
			totalCorrectionCount
			provisionalCorrectionCount
		}
		orderInfo {
			totalVoidCount
			provisionalVoidCount
			totalCorrectionCount
			provisionalCorrectionCount
		}

		tokens {
			id
			tokenActivatedDateTime
			canBePrimary
			statusReasonCodeDesc
			statusReasonCode
			tokenId
			status
			statusDescription
			isArchived
			frontendStatus
			subsystemTokenType
			mediaType
			tokenLastUsageDetails {
				transactionDateTime
				location
			}
			# WSTravelTokenUpgradeMediaOption
			upgradeMediaOptions {
				subsystemTokenType
				mediaType
			}
			replaceOrderInfo @include(if: $returnOrderInfo){
				orderId
			}
			# WSLeyValue
			restrictActions @include(if: $returnTravelTokenActions) {
				key
				value
			}
			tokenInfo {
				mobileWalletType
				mobileWalletDeviceType
				masterTokenPartial
				tokenNickname
				tokenType
				... on WSSubsystemAccountSmartcardTravelTokenDisplay {
					serialNumber
					cardExpiryDate
				}
					... on WSSubsystemAccountVirtualCardTravelTokenDisplay {
					maskedPan
					expirationMonth
					expirationYear
					cardParkedFlag
				}
					... on WSSubsystemAccountBankcardTravelTokenDisplay {
					maskedPan
					expirationMonth
					expirationYear
					creditCardType
				}
					tokenEnablementFee {
					status
					statusReasonCode
					statusLastUpdate
					feeDueAmount
				}
			}
		}
		purses {
			balance
			purseRestriction
			purseRestrictionDescription
			purseType
			purseTypeDescription
			supportsTransfer
		}
		passes {
			id
			passSKU
			createdDateTime
			travelTokenId
			passDescription
			expirationDateTime
			startDateTime
			endDateTime
			passSerialNbr
			supportsAutoload
			fareProductTypeId
			autoloadEnabled
			supportsTransfer
			firstUseDateTime
			passUseCount
			payments {
				paymentType
			}
		}
		# WSAutoloadSummary
		subscriptions @include(if: $returnSubscriptions) {
			id
			subscriptionId
			passId
			purseId
			status
			startDtm
			nickname
			purseRestriction
			purseType
			criteria {
				type
				thresholdValue
				day
				frequency
				recurrence
			}
			autoload {
				type
				loadValueBehavior
				...on WSAutoloadSubsystemValue {
					subsystemRef
					subsystemAccountId
				}
				...on WSAutoloadSubsystemProduct {
					subsystemAccountId
					productName
					productSKU
					travelTokenId
				}
			}
		}

		# WSProgramMembership
		programMemberships @include(if: $returnProgramMemberships) {
			id
			b2bCustomerId
			b2bCustomerName
			programId
			programName
			memberId
			memberStatus
			memberStatusShortDesc
			# WSMemberBenefit
			benefitElections {
				id
				benefitId
				benefitName
				benefitElectionId
				benefitDeliveryTypeId
				pretax
				electedAmount
			}
			memberStartDate
			memberExpirationDate
			memberExternalRef
		}
		# WSTransitAccountTransferProductInfo
		transferProductInfo @include(if: $returnTransferProductInfo) {
			totalTransferCount
			provisionalTransferCount
		}
	}
`;
